import React, { useEffect, useState, useContext } from 'react';
// import logo from "../assets/images/logo.gif";
import Quotes from '../components/Quotes';
// import Petro from '../components/Petro';
import TimeZones from '../components/TimeZones';
import Links from '../components/Links';
import Stories from '../components/Stories';
import Header from '../components/Header';
// import Tickers from '../components/Tickers';
import ApplicationContext from '../components/ApplicationContext';
// import {deepEqual, getDataWithFetch, getLocalStorage, setLocalStorage} from "../components/Utils";
import {deepEqual, getDataWithFetch, setLocalStorage} from "../components/Utils";
import "../assets/css/app.css";
import "../assets/css/likedislike.css";
import "../assets/css/topStories.css";
import "../assets/css/timezone.css";
import "../assets/css/filter.css";
import "../assets/css/checkbox.css";
import "../assets/css/quotes.css";
import "../assets/css/regions.css";
import "../assets/css/dropdown.css";
import "../assets/css/header.css";
import "../assets/css/translation.css";
import "../assets/css/carousel.css";

const HomePage = ({ setData }) => {
	const data = useContext(ApplicationContext);
	const [topStoriesResults, setTopStoriesResults] = useState();
	const [siteClosedFlag, setShowSiteClosedFlag] = useState(true);
	const [siteClosedMessage, setSiteClosedMessage] = useState("");
	const [siteClosedVideoUrls, setSiteClosedVideoUrls] = useState([]);
	const [currentVideoIndex, setCurrentVideoIndex] = useState(0);
	const [touchStart, setTouchStart] = useState(null);
	const [touchEnd, setTouchEnd] = useState(null);
	const [isSwiping, setIsSwiping] = useState(false);

	// Minimum swipe distance (in px)
	const minSwipeDistance = 50;
	const [selectedTimeZone, setSelectedTimeZone] = useState(null);
	const [currentTime, setCurrentTime] = useState("");

	// For now comment out the play button and just have the video display default to on
	/* eslint-disable no-lone-blocks, no-unused-vars */
	const [showVideo, setShowVideo] = useState(true);
	/* eslint-disable no-lone-blocks, no-unused-vars */

	const [isPremium, setIsPremium] = useState(false);	

	useEffect(() => {
		window.scrollTo(0, 0);
		// console.log('DEBUG', `HomePage:  isPremium = ${localStorage.getItem('is_premium')}`);
		setIsPremium(localStorage.getItem('is_premium') === '1' ? true : false);
	}, []);

	useEffect(() => {
		// console.log('DEBUG', `HomePage - data.BASE_URL = `, data.BASE_URL);
		// console.log('DEBUG', `HomePage - data.TopStoriesResults = `, data.TopStoriesResults);

		(async() => {
			if (data.BASE_URL) {
				// console.log('DEBUG:  BASE_URL - ', data.BASE_URL);
				let url = data.BASE_URL + "index.php/news_data/get_top_stories";
				const res = await getDataWithFetch(url);
				setTopStoriesResults(res);
				// console.log('DEBUG', `Stories - get_top_stories number of records ${res ? res.length : 0}`);
				if (!deepEqual(data.TopStoriesResults, res)) {
					data.TopStoriesResults = res;
				}

				// console.log('DEBUG:  output of update_reset_top_stories - ', typeof json, json);
			}
		})()
		// console.log('DEBUG', `HomePage - data.enableAdmin = ${data.enableAdmin}`);
	}, [data, data.BASE_URL, data.TopStoriesResults]);

	useEffect(() => {
		// console.log('DEBUG', `HomePage - data.siteClosedFlag = ${data.siteClosedFlag}`);
		// console.log('DEBUG', `HomePage - data.siteClosedMessage = ${data.siteClosedMessage}`);

		(async() => {
			// url = `${data.BASE_URL}index.php/misc/get_site_closed_flag`;
			// console.log('DEBUG:  Admin - ', url);
			// const json = await getDataWithFetch(url);
			// console.log('DEBUG: HomePage - data.siteClosedVideoUrls:', data.siteClosedVideoUrls);
			setShowSiteClosedFlag(!isPremium ? data.siteClosedFlag : false);
			setSiteClosedMessage(data.siteClosedMessage);
			setSiteClosedVideoUrls(data.siteClosedVideoUrls || []);
			// console.log('DEBUG: HomePage - After setSiteClosedVideoUrls:', data.siteClosedVideoUrls || []);
			
			// Load timezone data for temp page
			if (!isPremium && data.siteClosedFlag && data.BASE_URL) {
				const tzUrl = `${data.BASE_URL}index.php/misc/get_time_zones`;
				const timeZones = await getDataWithFetch(tzUrl);
				if (timeZones && Array.isArray(timeZones)) {
					const selected = timeZones.find(tz => tz.showOnTempPage);
					setSelectedTimeZone(selected || null);
				}
			}
			
			// console.log('DEBUG: HomePage - siteClosedVideoUrl:', data.siteClosedVideoUrl);
			// console.log('DEBUG:  HomePage - siteClosedFlag', data.siteClosedFlag);
			// console.log('DEBUG:  HomePage - siteClosedMessage', data.siteClosedMessage);
		})();
	}, [data, data.BASE_URL, data.siteClosedFlag, data.siteClosedVideoUrls, isPremium]);

	// Update time every second for timezone display
	useEffect(() => {
		const updateTime = () => {
			if (selectedTimeZone) {
				const now = new Date();
				const options = {
					hour: '2-digit',
					minute: '2-digit',
					// second: '2-digit',
					hour12: true
				};
				
				// If timeZone is empty string, use local time (don't specify timeZone option)
				if (selectedTimeZone.timeZone) {
					options.timeZone = selectedTimeZone.timeZone;
				}
				
				const timeString = now.toLocaleTimeString('en-US', options);
				setCurrentTime(timeString);
			}
		};

		updateTime();
		const interval = setInterval(updateTime, 1000);
		return () => clearInterval(interval);
	}, [selectedTimeZone]);

	const handleLanguageChange = async (language) => {
		// console.log('DEBUG', `HomePage:  new language selection is ${language}`);
		data.lang = language;
	};

	// Extract YouTube video ID from URL
	const getYouTubeVideoId = (url) => {
		if (!url) return null;
		const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=|shorts\/|live\/)([^#&?]*).*/;
		const match = url.match(regExp);
		const videoId = (match && match[2].length === 11) ? match[2] : null;
		// console.log('DEBUG: getYouTubeVideoId - URL:', url, '| Extracted Video ID:', videoId);
		return videoId;
	};

	// Check if the URL is a YouTube Short (vertical video)
	const isYouTubeShort = (url) => {
		if (!url) return false;
		return url.includes('/shorts/') || url.includes('youtube.com/shorts');
	};

	// Handle touch events for swipe
	const onTouchStart = (e) => {
		setTouchEnd(null);
		setTouchStart(e.targetTouches[0].clientX);
		setIsSwiping(true);
	};

	const onTouchMove = (e) => {
		if (!touchStart) return;
		setTouchEnd(e.targetTouches[0].clientX);
	};

	const onTouchEnd = () => {
		setIsSwiping(false);
		if (!touchStart || !touchEnd) return;
		
		const distance = touchStart - touchEnd;
		const isLeftSwipe = distance > minSwipeDistance;
		const isRightSwipe = distance < -minSwipeDistance;

		if (isLeftSwipe) {
			// Swipe left - go to next video
			setCurrentVideoIndex((prev) => prev === siteClosedVideoUrls.length - 1 ? 0 : prev + 1);
		}
		if (isRightSwipe) {
			// Swipe right - go to previous video
			setCurrentVideoIndex((prev) => prev === 0 ? siteClosedVideoUrls.length - 1 : prev - 1);
		}
		setTouchStart(null);
		setTouchEnd(null);
	};

	// this is basically just hardcoded to close the site, when it is open again, I will build it again and redeploy.
	// TODO:  probbly this coudl be added to the admin page to open/close the site.
	const [tickerNewsStories, setTickerNewsStories] = useState();

	useEffect(() => {
		if (siteClosedFlag) {
			import("../assets/css/site-closed.css");

			if (data.linkData) {
				const tmp = data.linkData.map(element => {
					// console.log('DEBUG:  ', element.URL);
					// console.log('DEBUG:  ', element.TITLE);
					return {
						title:element.TITLE,
						link:element.URL,
					}
				});
				// console.log('DEBUG:  tickerNewsStories - ', tmp);

				setTickerNewsStories(tmp);
			}

		}
		
		// if (data.siteClosedFlag) {
		// }
	}, [data.siteClosedFlag, siteClosedFlag, data, data.BASE_URL, data.currentPage, setData]);
	
	// useEffect(() => {
	// 	const username = getLocalStorage("username");
	// 	// console.log("DEBUG", `AdminPage:  username = ${username}`);
	// 	if (!username && username !== 'admin') {
	// 		setLocalStorage('currentPage', 'login');
	// 		data.currentPage = 'login';
	// 		setData((prev) => ({ ...prev, currentPage: 'login' }))
	// 	}
	// }, [data, data.currentPage, setData]);

	// const logout = (e) => {
	// 	e.preventDefault();
	// 	localStorage.removeItem('token');
	// 	localStorage.removeItem('username');
	// 	localStorage.removeItem('is_premium');
	// 	localStorage.removeItem('currentPage');
	
	// 	// This one is no longer need but clean it up if any user already 
	// 	// has it.  At some point we will just delete this.
	// 	localStorage.removeItem("ADMINUSER");
	
	// 	setData((prev) => ({ ...prev, currentPage: 'login' }))
	// 	setLocalStorage('currentPage', 'login');
	// 	data.currentPage = 'login';
	// };

	// TODO - JHP - I am not sure where Shafagh is going with this but I am keeping the code but just for now 
	// wrapping it around this conditional to not load it.
	const [loadTickers, setLoadTickers] = useState(false);
	const [TickersComponent, setTickersComponent] = useState(null);
	useEffect(() => {
		if (loadTickers) {
			// Conditionally import Tickers component only when loadTickers is true
			import('../components/Tickers').then(module => {
				setTickersComponent(() => module.default);
			});
		} else {
			setTickersComponent(null);
		}
	}, [loadTickers]);

	return (<>
		{/* {(() => {
			console.log('DEBUG:  admin NOT enabled')
		})()} */}
		{!siteClosedFlag && <Header onLanguageChange={handleLanguageChange} setData={setData} />}
		{!siteClosedFlag && <TimeZones />}
		{loadTickers && !siteClosedFlag && TickersComponent && <TickersComponent />}
		{!siteClosedFlag && <Quotes />}
		{/* {!siteClosedFlag && <Petro />} */}
		{!siteClosedFlag && <Links />}
		{!siteClosedFlag && <div className="all-links-container">
			{
				(topStoriesResults?.length > 0) && 
				<h3 className="all-links"><button className="link-button" onClick={(e) => {
					e.preventDefault();
					setLocalStorage('currentPage', 'topstories');
					data.currentPage = 'topstories';
					setData((prev) => ({ ...prev, currentPage: 'topstories' }))
				}}>Top Stories</button></h3>
			}
			<h3 className="all-links hide"><button className="link-button" onClick={(e) => {
					e.preventDefault();
					setLocalStorage('currentPage', 'faq');
					data.currentPage = 'faq';
					setData((prev) => ({ ...prev, currentPage: 'faq' }))
				}}>How Data is Aggregated on this site</button></h3>
			<h3 className="all-links hide"><button className="link-button" onClick={(e) => {
				e.preventDefault();
				setLocalStorage('currentPage', 'invest');
				data.currentPage = 'invest';
				setData((prev) => ({ ...prev, currentPage: 'invest' }))
			}}
			>Investor Relations</button></h3>
		</div>}
		{!siteClosedFlag && <Stories enableAdmin={false} topStories={false} />}
		{siteClosedFlag && <div className="site-closed-outer">
			{selectedTimeZone && (
				<div style={{
					position: 'absolute',
					top: '20px',
					left: '20px',
					color: '#0077FF',
					fontWeight: 'bold',
					fontSize: '16px',
					zIndex: 1000
				}}>
					<div>{selectedTimeZone.label}</div>
					<div style={{ fontSize: '14px', marginTop: '4px' }}>{currentTime}</div>
				</div>
			)}
  			{/* <h1>We're Closing Our Doors</h1> */}
			{/* Thank you for visiting our site. Unfortunately, we are no longer able to continue operations.
			We appreciate your support and understanding over the years.
			For any inquiries, please contact us at */}
			
			{/* Play button in top-left corner */}
			{/* For now comment out the play button and just have the video display default to on */}
			{/* {siteClosedVideoUrl && getYouTubeVideoId(siteClosedVideoUrl) && (
				<button 
					className="video-play-button" 
					onClick={() => setShowVideo(!showVideo)}
					aria-label="Toggle video"
				>
					{showVideo ? '✕' : '▶'}
				</button>
			)} */}

			<div className="site-closed-center">
				{/* YouTube video with swipe navigation */}
				{showVideo && siteClosedVideoUrls.length > 0 && getYouTubeVideoId(siteClosedVideoUrls[currentVideoIndex]) && (
					<div className="video-carousel-wrapper">
						{siteClosedVideoUrls.length > 1 && (
							<button 
								className="carousel-nav carousel-nav-left desktop-only"
								onClick={() => setCurrentVideoIndex((prev) => prev === 0 ? siteClosedVideoUrls.length - 1 : prev - 1)}
								aria-label="Previous video"
							>
								‹
							</button>
						)}
						<div className={`video-container ${isYouTubeShort(siteClosedVideoUrls[currentVideoIndex]) ? 'vertical' : ''}`}>
							<iframe
								width="560"
								height="315"
								src={`https://www.youtube.com/embed/${getYouTubeVideoId(siteClosedVideoUrls[currentVideoIndex])}?autoplay=1&rel=0&modestbranding=1`}
								title="YouTube video player"
								frameBorder="0"
								allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
								sandbox="allow-same-origin allow-scripts allow-presentation allow-forms"
								allowFullScreen
								referrerPolicy="strict-origin-when-cross-origin"
							></iframe>
							{siteClosedVideoUrls.length > 1 && (
								<>
									<div 
										className="swipe-zone swipe-zone-left"
										onTouchStart={onTouchStart}
										onTouchMove={onTouchMove}
										onTouchEnd={onTouchEnd}
									></div>
									<div 
										className="swipe-zone swipe-zone-right"
										onTouchStart={onTouchStart}
										onTouchMove={onTouchMove}
										onTouchEnd={onTouchEnd}
									></div>
								</>
							)}
						</div>
						{siteClosedVideoUrls.length > 1 && (
							<button 
								className="carousel-nav carousel-nav-right desktop-only"
								onClick={() => setCurrentVideoIndex((prev) => prev === siteClosedVideoUrls.length - 1 ? 0 : prev + 1)}
								aria-label="Next video"
							>
								›
							</button>
						)}
						{siteClosedVideoUrls.length > 1 && (
							<div className="carousel-dots">
								{siteClosedVideoUrls.map((_, index) => (
									<span 
										key={index}
										className={`carousel-dot ${index === currentVideoIndex ? 'active' : ''}`}
										onClick={() => setCurrentVideoIndex(index)}
									></span>
								))}
							</div>
						)}
					</div>
				)}

				{/* Temporarily removing the logo */}
				{/* {!siteClosedVideoUrl && (
					<img src={logo} alt="Site Logo" className="site-closed-logo" />
				)} */}

				<div className="site-closed-message-row">
					<span className="site-closed-message">{siteClosedMessage}</span>
					{/*  <a href="mailto:team@dayseenk.com" className="site-closed-email">team@dayseenk.com</a> */}
				</div>
			</div>
			{/* {(() => {
				tickerNewsStories?.forEach(element => {
					console.log('DEBUG:  ', element.link);
				});
			})()} */}
			{tickerNewsStories && (() => {
				// Calculate total character count for ticker titles
				const tickerCharCount = tickerNewsStories.slice(0, 10).reduce((acc, entry) => acc + (entry.title ? entry.title.length : 0), 0);
				// Adjust the multiplier (seconds per character) for desired speed
				const tickerDuration = Math.max(10, tickerCharCount * 0.08); // 0.08s per char, min 10s
				return (
					<div className="carousel-container carousel-container-outer">
						<ul className="carousel-list carousel-list-additional" style={{animation: `scrollLeft ${tickerDuration}s linear infinite`}}>
							{tickerNewsStories.slice(0,10).map((entry, index) => {
								let link = `${entry.link}`;
								return (<li key={index} aria-hidden="true"><a href={link} className="carousel-font1" target="_blank" rel="noreferrer">{entry.title}</a></li>);
							})}
							{tickerNewsStories.slice(0,10).map((entry, index) => {
								let link = `${entry.link}`;
								return (<li key={index+10} aria-hidden="true"><a href={link} className="carousel-font1" target="_blank" rel="noreferrer">{entry.title}</a></li>);
							})}
						</ul>
					</div>
				);
			})()}
			{/* <button onClick={logout} className="your-link-style logout-button">Logout</button> */}
		</div>}
	</>);
}

export default HomePage;
